import Alert from '@material-ui/lab/Alert';
import React from 'react';

function ExportWarning() {
  return (
    <Alert severity='warning' style={{ marginBottom: 16 }}>
      Para garantir maior segurança, a exportação de relatórios via e-mail agora está restrita a endereços previamente autorizados. Se precisar
      adicionar um novo e-mail, acesse as configurações de controle de acesso.
    </Alert>
  );
}

export default ExportWarning;
